import React from "react";

const WhatsAppButton = () => {
    const phoneNumber = "5579998830315";
    const message = encodeURIComponent("Olá! Estou no NeoApp e gostaria de falar com o suporte.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="Fale com o Suporte"
            className="floating-support-btn bg-primary text-white shadow-lg d-flex justify-content-center align-items-center"
        >
            <i className="mdi mdi-whatsapp"></i>
        </a>
    );
};

export default WhatsAppButton;
